






import { FormsService } from "@/modules/Forms/services/FormService";
import { FormTemplateService } from "@/modules/FormTemplate/services/FormTemplateService";
import { InfoGroupService } from "@/modules/InfoGroup/services/InfoGroupService";
import { ListService } from "@/modules/List/services/ListService";
import { AuthService } from "@/modules/Login/services/AuthService";
import { NotificationService } from "@/modules/Notification/services/NotificationService";
import { UserTemplateService } from "@/modules/UserTemplate/services/UserTemplateService";
import { RolesService } from "@/modules/Roles/services/RolesService";
import { Component, Provide, Vue } from "vue-property-decorator";
import { UserService } from "../modules/User/services/UserService";
import { ServiceTemplateService } from "../modules/ServiceTemplate/services/ServiceTemplateService";
import { SessionTemplateService } from "@/modules/SessionTemplate/services/SessionTemplateService";
import { ServicesService } from "@/modules/Services/services/ServicesService";
import { CupsPriceLevelService } from "@/modules/CupsPriceLevels/services/CupsPriceLevelService";
import { OrderService } from "@/modules/Orders/services/OrderService";
import { RuleService } from "@/modules/Rules/services/RuleService";
import { TaskService } from "@/modules/Tasks/services/TaskService";
import { MedicalOrderService } from "@/modules/MedicalOrder/services/MedicalOrderService";
import { DashboardService } from "@/modules/Dashboards/AdminDashboard/services/DashboardService";
import { ManagedListsService } from "@/shared/services/ManagedListsService";
import { CampusService } from "@/modules/Campus/services/CampusService";
import { EventService } from "@/modules/Events/services/EventService";
import { DependenciesService } from "../modules/Dependencies/services/DependenciesService";
import { SpaceService } from "@/modules/Space/services/SpaceService";
import { AvailabilityService } from "@/modules/Availability/services/AvailabilityService";
import { DocumentService } from "@/modules/Document/services/DocumentService";
import { MedicalAppointmentService } from "@/modules/MedicalAppointment/services/MedicalAppointmentService";
import { DoctorProfileService } from "@/modules/DoctorProfile/services/DoctorProfileService";
import { EmailService } from "@/modules/Email/services/EmailService";
import { NotificationTemplateServices } from "@/modules/NotificationTemplate/services/NotificationTemplateService";
import { GeneralRulesService } from "@/modules/GeneralRules/services/GeneralRulesService";
import { TemplatePdfService } from "@/modules/TemplatePdf/services/templatePdfService";
import { MultimediaService } from "@/modules/Multimedia/services/MultimediaService";
import { ActionPlanService } from "@/modules/ActionPlan/services/ActionPlanService";
import { SessionService } from "@/modules/Sessions/services/SessionService";
import { AvailabilityTemplateService } from "@/modules/AvailabilityTemplate/services/AvailabilityTemplateService";
import { ChatService } from "@/modules/Home/components/ChatWindow/Services/ChatWindow.service";

@Component({
  name: "ServiceProvider"
})
export default class ServiceProvider extends Vue {
  @Provide()
  formTemplateService: FormTemplateService = new FormTemplateService();
  @Provide()
  listService: ListService = new ListService();
  @Provide()
  authService: AuthService = new AuthService();
  @Provide()
  formsService: FormsService = new FormsService();
  @Provide()
  notificationService: NotificationService = new NotificationService();
  @Provide()
  infoGroupService: InfoGroupService = new InfoGroupService();
  @Provide()
  userTemplateService: UserTemplateService = new UserTemplateService();
  @Provide()
  userService: UserService = new UserService();
  @Provide()
  rolesService: RolesService = new RolesService();
  @Provide()
  serviceTemplateService: ServiceTemplateService = new ServiceTemplateService();
  @Provide()
  sessionTemplateService: SessionTemplateService = new SessionTemplateService();
  @Provide()
  servicesService: ServicesService = new ServicesService();
  @Provide()
  cupsPriceLevelService: CupsPriceLevelService = new CupsPriceLevelService();
  @Provide()
  orderService: OrderService = new OrderService();
  @Provide()
  ruleService: RuleService = new RuleService();
  @Provide()
  taskService: TaskService = new TaskService();
  @Provide()
  medicalOrderService: MedicalOrderService = new MedicalOrderService();
  @Provide()
  managedListsService: ManagedListsService = new ManagedListsService();
  @Provide()
  dashboardService: DashboardService = new DashboardService();
  @Provide()
  campusService: CampusService = new CampusService();
  @Provide()
  eventService: EventService = new EventService();
  @Provide()
  dependenciesService: DependenciesService = new DependenciesService();
  @Provide()
  spaceService: SpaceService = new SpaceService();
  @Provide()
  availabilityService: AvailabilityService = new AvailabilityService();
  @Provide()
  documentService: DocumentService = new DocumentService();
  @Provide()
  medicalAppointmentService: MedicalAppointmentService = new MedicalAppointmentService();
  @Provide()
  doctorProfileService: DoctorProfileService = new DoctorProfileService();
  @Provide()
  emailService: EmailService = new EmailService();
  @Provide()
  notificationTemplateService: NotificationTemplateServices = new NotificationTemplateServices();
  @Provide()
  generalRulesService: GeneralRulesService = new GeneralRulesService();
  @Provide()
  templatePdfService: TemplatePdfService = new TemplatePdfService();
  @Provide()
  multimediaService: MultimediaService = new MultimediaService();
  @Provide()
  actionPlanService: ActionPlanService = new ActionPlanService();
  @Provide()
  sessionService: SessionService = new SessionService();
  @Provide()
  availabilityTemplateService: AvailabilityTemplateService = new AvailabilityTemplateService();
  @Provide()
  chatService: ChatService = new ChatService();
}
